import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const FeaturedSections = ({ featured }) => {
  const defaults = [
    { id: 1, title: 'Paisley Abbey', description: "A medieval marvel dating back to the 12th century — one of Scotland's most historic landmarks.", image: `${process.env.REACT_APP_BACKEND_URL}/api/files/paisley-org/wp-content/uploads/2025/09/Paisley-skyline-from-abbey-770x513-1.jpg`, link: '/history', badge: 'Heritage', glow: 'from-sky-400 to-blue-500' },
    { id: 2, title: 'Paisley Museum', description: 'Reopened after a £45 million transformation — a world-class destination celebrating the town\'s heritage.', image: 'https://customer-assets.emergentagent.com/job_07e05c69-0586-4274-8381-f4bbddcb034e/artifacts/bdl556y9_DJI_0001.JPG', link: '/attractions', badge: 'Culture', glow: 'from-fuchsia-400 to-pink-500' },
    { id: 3, title: 'Paisley First', description: 'The non-profit BID delivering town-centre revitalisation across Paisley.', image: 'https://customer-assets.emergentagent.com/job_07e05c69-0586-4274-8381-f4bbddcb034e/artifacts/bdl556y9_DJI_0001.JPG', link: 'https://www.paisleyfirst.com/', badge: 'Community', external: true, glow: 'from-orange-400 to-amber-500' },
  ];
  const sections = (featured && featured.length > 0 ? featured : defaults).slice(0, 3);
  if (!sections.length) return null;

  return (
    <section className="relative py-24" data-testid="featured-sections">
      <div className="aurora-orb w-[420px] h-[420px] top-20 right-1/4 bg-fuchsia-200/40" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="mb-10">
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-sky-600 mb-3">Highlights</p>
          <h2 className="text-5xl md:text-6xl font-bold tracking-[-0.04em] text-slate-900 leading-none">
            Worth a <span className="font-serif-accent italic font-light bg-gradient-to-r from-sky-500 to-orange-500 bg-clip-text text-transparent">closer look</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {sections.map((s) => {
            const props = s.external ? { href: s.link, rel: 'noopener noreferrer' } : { href: s.link };
            return (
              <a
                key={s.id}
                {...props}
                className="group glass rounded-3xl overflow-hidden glass-hover relative"
                data-testid={`featured-card-${s.id}`}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[900ms]"
                    onError={(e) => { e.target.src = '/api/files/paisley-org/wp-content/uploads/2025/09/Paisley-skyline-from-abbey-770x513-1.jpg'; }}
                  />
                  <span className={`absolute top-3 left-3 glass-strong rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-slate-700`}>{s.badge || 'Story'}</span>
                </div>
                <div className="p-6 md:p-7">
                  <h3 className="text-2xl font-bold tracking-[-0.03em] text-slate-900 group-hover:text-sky-600 transition-colors">{s.title}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-3">{s.description}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-sky-600 group-hover:gap-2.5 transition-all">
                    Read on <ArrowUpRight size={13} />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedSections;
